import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import axios from 'axios';
import {getToken, saveToken} from './Utils/loginUtil';

axios.interceptors.request.use(function (config) {
    const token = getToken();

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

axios.interceptors.response.use(undefined, function (error) {
    if (error.response.status === 401) {
        saveToken(null);
        location.reload();
    }
    return Promise.reject(error);
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
